<button id="link-button" mat-button color="primary" (click)="openPlaidLink()">
    Link Your Bank Account
  </button>